export const SET_PDS_DOCUMENT_LIST = 'CBRE-PJM-DOCUMENTS-FILE-UPLOAD/SET_PDS_DOCUMENT_LIST';
export const MODULE = 'cbre-pjm-principal-lite-project-documents';
